module.exports = __webpack_public_path__ + "static/about-admin-7b9a7f9d5a21813122dc9a81c90cabc1.png";